import { AppstoreAddOutlined } from '@ant-design/icons';
import { getArrayWidgetReference } from '../../../../expressions/references/builder/getArrayWidgetReference';
import { RepeatableRangeRule } from '../../../../rules/repository/repeatable-range/RepeatableRange.rule';
import { UniqueFieldRule } from '../../../../rules/repository/unique-field-rule/UniqueFieldRule.rule';
import { tran } from '../../../../translations/schema/TranslationSchema';
import type { IWidgetType } from '../../../IWidgetType';
import { WidgetCategory, WidgetMainType, WidgetType } from '../../../Widget';
import { IRepeatableWidget } from './IRepeatableWidget';
import { RepeatableWidgetComponent } from './RepeatableWidgetComponent';
import { RepeatableWidgetConfigComponent } from './RepeatableWidgetConfigComponent';
import { RepeatableWidgetConfigSchema } from './RepeatableWidgetConfigSchema';
import { RepeatableWidgetPreview } from './RepeatableWidgetPreview';
import { createRepeatableSchema } from './createRepeatableSchema';
import { hydrateRepeatableWidget } from './hydrateRepeatableWidget';

/**
 * Tipo del componente  contenitore di una lista ripetibile di Widget.
 */
export const RepeatableWidgetType: IWidgetType<IRepeatableWidget> = {
  type: WidgetType.Repeatable,
  mainType: WidgetMainType.Container,
  category: WidgetCategory.Advanced,
  name: 'Lista Ripetibile',
  icon: <AppstoreAddOutlined rotate={-90} />,
  hasValue: true,
  getReference: getArrayWidgetReference,
  formComponent: RepeatableWidgetComponent,
  hydrate: hydrateRepeatableWidget,
  createFormSchema: createRepeatableSchema,
  configComponent: RepeatableWidgetConfigComponent,
  configOptions: {
    removeCollapsePanel: true,
  },
  configValidator: RepeatableWidgetConfigSchema,
  previewComponent: RepeatableWidgetPreview,
  translationSchema: tran.widget({
    label: tran.rte(),
    helpText: tran.rte(),
    description: tran.rte(),
    layout: tran.object({
      buttonText: tran.string(),
    }),
    rules: tran.rules(),
  }),
  rules: [RepeatableRangeRule, UniqueFieldRule],
};
